import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Box, Fade, Flex, HR, Metadata } from 'ui/acro'
import FooterLinks from './FooterLinks'
import {
  TERMS_OF_SERVICE_URL,
  PRIVACY_POLICY_URL,
  COOKIE_POLICY_URL
} from 'components_v1/SchemaSectionRenderer/common/components/constants'
import styled from 'styled-components'

const FooterContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  .footer-box {
    margin: 48px 0;
  }
`

const Footer = ({ links }) => {
  const year = new Date().getFullYear()

  return (
    <Fade>
      <Fragment>
        <Box width='100%'>
          <HR />
          <FooterContainer>
            <HR />
            <div className='footer-box'>
              {links && <FooterLinks />}
              <Flex justifyContent='center'>
                <Metadata margin='0 0 8px 0'>
                  &copy; {year} ALO Wellness Club. All Rights Reserved.
                </Metadata>
              </Flex>
              <Flex justifyContent='center'>
                <Metadata
                  cursor='pointer'
                  mb='0px'
                  mr='16px'
                  id='terms'
                  as='a'
                  href={TERMS_OF_SERVICE_URL}
                  target='_blank'
                >
                  Terms
                </Metadata>
                <Metadata
                  cursor='pointer'
                  mb='0px'
                  id='privacy'
                  as='a'
                  href={PRIVACY_POLICY_URL}
                  target='_blank'
                >
                  Privacy
                </Metadata>
                <Metadata
                  cursor='pointer'
                  ml='16px'
                  mb='0px'
                  id='privacy'
                  as='a'
                  href={COOKIE_POLICY_URL}
                  target='_blank'
                >
                  Cookie Policy
                </Metadata>
                <Metadata
                  cursor='pointer'
                  onClick={() => window.Osano?.cm?.showDrawer()}
                  ml='16px'
                  mb='0px'
                  id='cookies'
                >
                  Cookie Preferences
                </Metadata>
              </Flex>
            </div>
          </FooterContainer>
        </Box>
      </Fragment>
    </Fade>
  )
}

Footer.defaultProps = {
  links: true,
  flush: {
    mobile: false,
    desktop: false
  }
}

Footer.propTypes = {
  links: PropTypes.bool,
  flush: PropTypes.object
}

export default Footer
